import * as React from 'react';
import { clsx } from 'clsx';

import * as style from './HeaderCell.css';
import { getCellStyle } from '../../../../utils/table';

export interface IHeaderCellProps {
  position?: number;
  published?: boolean;
  sticky?: boolean;
}

export const HeaderCell = (props: React.PropsWithChildren<IHeaderCellProps>) => {
  const { children, position, published = true, sticky = false } = props;
  const styles = React.useMemo(() => getCellStyle(position), [position]);

  return (
    <div
      style={styles}
      className={clsx(
        style['head-cell'],
        sticky && style['head-cell--sticky'],
        !published && style['head-cell--unpublished'],
      )}
    >
      {children}
    </div>
  );
};
